import Cart from '@/views/cart/Cart.vue';
export default [
  {
    path: '/cart',
    name: 'cart',
    meta: {
      keepAlive: true
    },
    component: Cart
  },
  {
    path: '/addOnItem',
    name: 'addOnItem',
    component: () =>
      import(
        /* webpackChunkName: "additionalItemsForFreeShipping" */ '@/views/cart/AdditionalItemsForFreeShipping.vue'
      )
  }
];
